import React, { Suspense } from 'react';
import { AppLoading } from '../../../../../../loaders/loaders';
import Grid from '../Grid/Grid';

const TabContainer = ({ tabId, dataList, tabConfig, ...props }) => {
  const GridComponent = (
    <Grid
      gridConfig={tabConfig[tabId].gridConfig}
      dataList={dataList[tabConfig[tabId].dataListKey]}
      tabId={tabId}
      tabConfig={tabConfig}
      {...props}
    />
  );
  return <Suspense fallback={<AppLoading />}>{GridComponent}</Suspense>;
};

export default TabContainer;
